import { render, staticRenderFns } from "./my-cdk.vue?vue&type=template&id=12e1bf83&scoped=true&"
import script from "./my-cdk.vue?vue&type=script&lang=js&"
export * from "./my-cdk.vue?vue&type=script&lang=js&"
import style0 from "./my-cdk.vue?vue&type=style&index=0&id=12e1bf83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e1bf83",
  null
  
)

export default component.exports